// Resale Orders
export const GET_RESALE_ORDERS = `
  query GetResaleOrders($search: String, $status: String, $dateRange: String) {
    resaleOrders(search: $search, status: $status, dateRange: $dateRange) {
      id
      customer {
        name
        email
      }
      items {
        id
        name
        price
      }
      total
      status
      createdAt
    }
  }
`;

// Resale Items
export const GET_RESALE_ITEMS = `
  query GetResaleItems($filters: ResaleItemFilters) {
    resaleItems(filters: $filters) {
      id
      name
      category
      status
      resalePrice
      listedAt
    }
  }
`;

export const GET_RESALE_ITEM = `
  query GetResaleItem($id: ID!) {
    resaleItem(id: $id) {
      id
      name
      sku
      category
      status
      resalePrice
      originalPrice
      timeListed
      listedAt
      profitMargin
      condition
      size
      location
      originChannel
      repairCost
      carbonSavings
      specifications {
        brand
        material
        color
      }
      history {
        title
        location
        date
      }
    }
  }
`;

// Resale Analytics
export const GET_RESALE_ANALYTICS = `
  query GetResaleAnalytics {
    resaleAnalytics {
      salesPerformance {
        date
        value
      }
      categoryDistribution {
        category
        count
      }
    }
  }
`;

// Resale Metrics
export const GET_RESALE_METRICS = `
  query GetResaleMetrics {
    resaleMetrics {
      revenue {
        value
        change
        trend
      }
      itemsListed {
        value
        change
        trend
      }
      timeToList {
        value
        change
        trend
      }
      profitMargin {
        value
        change
        trend
      }
      revenueChart {
        date
        value
      }
      categoryChart {
        category
        count
      }
    }
  }
`;

// Resale Environment
export const GET_ENVIRONMENT_METRICS = `
  query GetEnvironmentMetrics($timeRange: String) {
    environmentMetrics(timeRange: $timeRange) {
      carbonSavings {
        value
        trend
        change
      }
      waterSaved {
        value
        trend
        change
      }
      materialsSaved {
        value
        trend
        change
      }
      landfillAvoided {
        value
        trend
        change
      }
      carbonSavingsChart {
        date
        value
      }
      impactByCategory {
        category
        carbonSaved
      }
      equivalencies {
        trees
        cars
        homes
      }
      goals {
        id
        name
        current
        target
        unit
        progress
        status
      }
    }
  }
`;

// Resale Settings
export const GET_RESALE_SETTINGS = `
  query GetResaleSettings {
    resaleSettings {
      programName
      description
      defaultPricingStrategy
      minimumCondition
      autoListItems
      commissionRate
      minimumPrice
      maximumPrice
      pricingStrategy
      acceptedPaymentMethods
      requireInspectionPhotos
      qualityGrades
      inspectionChecklist
      photoRequirements
      defaultShippingMethod
      shippingProviders
      packagingRequirements
      returnShippingMethod
      lowStockThreshold
      autoRemoveAfterDays
      locationTracking
      barcodeScanning
      returnPeriod
      customerServiceEmail
      automaticEmails
      productDescriptionTemplate
      carbonOffsetEnabled
      recyclingPartners
      sustainabilityMetrics
      impactReporting
      notificationEmails
      alertThresholds {
        lowStock
        highDemand
        priceChange
      }
      marketplaceIntegrations
      apiEndpoints
      webhookUrls
      termsAndConditions
      privacyPolicy
      returnPolicy
      prohibitedItems
      analyticsEnabled
      reportSchedule
      customMetrics
      rolePermissions
      approvalWorkflow
    }
  }
`;

export const UPDATE_RESALE_SETTINGS = `
  mutation UpdateResaleSettings($input: UpdateResaleSettingsInput!) {
    updateResaleSettings(input: $input) {
      programName
      description
      defaultPricingStrategy
      minimumCondition
      autoListItems
      commissionRate
      minimumPrice
      maximumPrice
      pricingStrategy
      acceptedPaymentMethods
      requireInspectionPhotos
      qualityGrades
      inspectionChecklist
      photoRequirements
      defaultShippingMethod
      shippingProviders
      packagingRequirements
      returnShippingMethod
      lowStockThreshold
      autoRemoveAfterDays
      locationTracking
      barcodeScanning
      returnPeriod
      customerServiceEmail
      automaticEmails
      productDescriptionTemplate
      carbonOffsetEnabled
      recyclingPartners
      sustainabilityMetrics
      impactReporting
      notificationEmails
      alertThresholds {
        lowStock
        highDemand
        priceChange
      }
      marketplaceIntegrations
      apiEndpoints
      webhookUrls
      termsAndConditions
      privacyPolicy
      returnPolicy
      prohibitedItems
      analyticsEnabled
      reportSchedule
      customMetrics
      rolePermissions
      approvalWorkflow
    }
  }
`;

// Resale Financials
export const GET_RESALE_FINANCIALS = `
  query GetResaleFinancials {
    resaleFinancials {
      metrics {
        revenue {
          value
          trend
          change
        }
        profit {
          value
          trend
          change
        }
        margin {
          value
          trend
          change
        }
        averageOrder {
          value
          trend
          change
        }
      }
      revenueOverTime {
        date
        value
      }
      revenueByCategory {
        category
        value
      }
      transactions {
        id
        date
        type
        item
        amount
        profit
        customer
        status
      }
    }
  }
`;

// Resale Environment
export const GET_RESALE_ENVIRONMENT = `
  query GetResaleEnvironment {
    resaleEnvironment {
      carbonSavings {
        date
        value
      }
      materialRecovery {
        material
        amount
      }
    }
  }
`;

// Mutations
export const UPDATE_RESALE_STATUS = `
  mutation UpdateResaleStatus($itemId: ID!, $status: String!) {
    updateResaleStatus(itemId: $itemId, status: $status) {
      id
      status
    }
  }
`;

export const UPDATE_RESALE_ITEM = `
  mutation UpdateResaleItem($itemId: ID!, $data: UpdateResaleItemInput!) {
    updateResaleItem(id: $itemId, data: $data) {
      id
      name
      category
      status
      resalePrice
      specifications
    }
  }
`; 